/* Shto jump: a button or rating line inside our sections that links to "#something" on the page glides there, without
   adding "#..." to the address (development.md soft rule).
   Myoxcience's header (Hyper theme) stays pinned to the top of the screen, so every jump stops with its target just under
   the header. The theme keeps the header's height in --header-height. Loaded by every section with a jump link; runs once. */
(function () {
  if (window.ShtoJump) return;
  window.ShtoJump = true;

  // A page opens at the top even when its address ends in #shto-... (a link shared with a section's id). The address
  // itself is never changed.
  if (/^#shto-/.test(location.hash)) {
    var toTop = function () { window.scrollTo({ top: 0, behavior: 'instant' }); };
    toTop();
    if (document.readyState === 'complete') setTimeout(toTop, 0);
    else window.addEventListener('load', function () { toTop(); setTimeout(toTop, 0); }, { once: true });
  }

  function headerHeight() {
    return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.shto a[href^="#"]');
    if (!link || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var id = decodeURIComponent(link.getAttribute('href').slice(1));
    var target = id && document.getElementById(id);
    if (!target) return;
    e.preventDefault();

    function where() {
      return Math.max(0, Math.round(target.getBoundingClientRect().top + window.scrollY - headerHeight()));
    }
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: where(), behavior: still ? 'auto' : 'smooth' });
    // Photos loading on the way can move the target while the page glides. Once it stops, nudge it into place.
    var done = false;
    function settle() {
      if (done) return; done = true;
      window.removeEventListener('scrollend', settle);
      var off = where() - Math.round(window.scrollY);
      if (Math.abs(off) > 1) window.scrollBy({ top: off, behavior: still ? 'auto' : 'smooth' });
    }
    if ('onscrollend' in window) {
      window.addEventListener('scrollend', settle);
      if (Math.abs(window.scrollY - where()) < 2) settle();
    } else setTimeout(settle, 1500);
    if (target.tabIndex < 0 && !/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(target.tagName)) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });
})();
